<template>
  <div class="contact-us">
    <div class="contact-us__textbox">
      <h2 class="lma-headline">
        Visionary creations.<br class="br-mobile" />
        Inspired solutions.<br class="br-desktop" /><br class="br-mobile" />
        Immersive experiences.
      </h2>
      <div class="lma-bodycopy contact-us__bodycopy">
        Sensory spatial experiences that blur the boundaries between reality and
        virtuality.<br class="br-desktop" />
        Build your own media art, from space and media design to content
        provision and operations, using our in-depth understanding of space and
        screens.
      </div>
    </div>
    <div class="contact-us__contents">
      <div ref="carousel" class="lma-flexbox contact-us__cards">
        <div class="lma-card contact-us__card contact-us__card--1">
          <div class="lma-card__title contact-us__title">
            Business and<br class="br-desktop" /><br class="br-mobile" />
            space analysis
          </div>
          <div class="lma-card__image contact-us__image">
            <img
              src="/theme/rbFront/img/w/mediaArtSolution/contactus01.png"
              alt=""
            />
          </div>
        </div>
        <div class="lma-card contact-us__card contact-us__card--2">
          <div class="lma-card__title contact-us__title">
            Space design with professional<br class="br-desktop" />
            display technology
          </div>
          <div class="lma-card__image contact-us__image">
            <img
              src="/theme/rbFront/img/w/mediaArtSolution/contactus02.png"
              alt=""
            />
          </div>
        </div>
        <div class="lma-card contact-us__card contact-us__card--3">
          <div
            class="lma-card__title contact-us__title contact-us__title--dark"
          >
            Content proposal
          </div>
          <div class="lma-card__image contact-us__image">
            <img
              src="/theme/rbFront/img/w/mediaArtSolution/contactus03.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionContactUs',
  data() {
    return {
      slickInitialized: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initSlick()
      window.addEventListener('resize', this.handleResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    this.destroySlick()
  },
  methods: {
    /* eslint-disable no-undef */
    initSlick() {
      if (window.innerWidth <= 1080 && !this.slickInitialized) {
        $(this.$refs.carousel).slick({
          // Slick 옵션 설정
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          centerMode: true,
          arrows: false,
        })
        this.slickInitialized = true
      }
    },
    destroySlick() {
      if (this.slickInitialized) {
        $(this.$refs.carousel).slick('unslick')
        this.slickInitialized = false
      }
    },
    /* eslint-enable no-undef */
    handleResize() {
      if (window.innerWidth <= 1080) {
        this.initSlick()
      } else {
        this.destroySlick()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.contact-us {
  display: flex;
  flex-direction: column;
  padding: 80px 0;
  gap: calc(60px + 62px); // gap + card step number height
  &__bodycopy {
    width: 80%;
    margin: 16px auto 0;
  }
  &__cards {
    box-sizing: border-box;
    gap: 20px;
  }
  &__card {
    position: relative;
    box-sizing: border-box;
    flex: 1;
    background-color: #9a9a9a;
    &::before {
      content: 'Step 1';
      position: absolute;
      top: -24px;
      left: 50%;
      transform: translate(-50%, -100%);
      display: inline-flex;
      align-items: center;
      height: 38px;
      padding: 0 16px;
      background-color: #000;
      color: #fff;
      border-radius: 500px;
      z-index: 10;
    }
    &::after {
      content: '';
      position: absolute;
      top: -43px;
      left: 100%;
      transform: translate(-50%, -100%);
      width: 100%;
      height: 1px;
      border-bottom: dashed 1px #666;
      z-index: 9;
    }
    &--2 {
      &::before {
        content: 'Step 2';
      }
    }
    &--3 {
      &::before {
        content: 'Step 3';
      }
      &::after {
        display: none;
      }
    }
  }
  &__title {
    position: absolute;
    width: 100%;
    padding: 0 48px;
    box-sizing: border-box;
    color: #fff;
    left: 50%;
    top: 60px;
    transform: translateX(-50%);
    z-index: 2;
    &--dark {
      color: #000;
    }
  }
  &__image {
    font-size: 0;
    img {
      border-radius: 40px;
      width: 100%;
      height: auto;
    }
  }
  &__banner-text {
    padding-left: 112px;
    background: url('/theme/rbFront/img/w/mediaArtSolution/icon_message.png')
      no-repeat left center;
  }
  @media screen and (max-width: 1080px) {
    gap: 62px;
    padding: 40px 0;

    &__cards {
      height: auto;
      display: block;
    }
    &__bodycopy {
      width: 100%;
    }
    &__card {
      padding: 0 4px;
      background-color: transparent;
      &::before {
        top: -12px;
        height: 30px;
      }
      &::after {
        top: -27px;
        left: 100%;
      }
    }
    &__title {
      font-size: 20px;
      line-height: 24px;
      top: 28px;
      width: 80%;
      padding: 0 0;
    }
    &__image {
      position: static;
      font-size: 0;
      img {
        border-radius: 24px;
      }
    }
    &__banner-text {
      padding-left: 0;
      padding-top: 76px;
      background-position: top center;
      background-size: 60px 60px;
    }
    ::v-deep .slick-list {
      overflow: visible;
    }
  }
}
</style>
